<template>
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.74219 5.2585C9.74219 7.79749 6.74844 10.443 6 10.443C5.25156 10.443 2.25781 7.79749 2.25781 5.2585C2.25781 3.21328 3.93325 1.5553 6 1.5553C8.06675 1.5553 9.74219 3.21328 9.74219 5.2585Z"
            stroke="var(--app-icons)"
            stroke-width="0.70166"
        />
        <circle
            cx="1.40332"
            cy="1.40332"
            r="1.40332"
            transform="matrix(-1 0 0 1 7.40332 3.66028)"
            stroke="var(--app-icons)"
            stroke-width="0.70166"
        />
    </svg>
</template>
